import SelectForm from "../../Components/SelectForm/SelectForm";
import InputForm, {
  AutoCompleteValue,
} from "../../Components/InputForm/InputForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import React from "react";
import { useState, useEffect } from "react";
import {
  CommonDropdownData,
  insertUpdateEmployeedetails,
  getEmploymentDetailsByMemberId,
  getCoreUsersEmploymentDetailsByTokenNo,
  getUnitCodeDropdownById,
  getPersonalDetailsByMemberId,
  GetLocationData,
} from "../../Helpers/APIEndPoints/EndPoints";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { GetCoreUsersEmploymentDetailsByTokenNoResponseModel } from "../../Models/GetCoreUsersEmploymentDetailsByTokenNoResponseModel";
import { allSettled } from "q";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { randomNumber } from "../../Helpers/Common";
import { enableTestData } from "../../Helpers/Constants/Constants";
import { MemberRegistrationUserType } from "../../Helpers/Enums/MemberRegistrationUserType";
import { useSelector } from "react-redux";
// interface Options {
//     label?:any;
//     value?:any;
// }
const EmployeeDetails = (props) => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const [companyOptions, setCompanyOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [unitcodeOptions, setUnitCodeOptions] = useState([]);
  const memberid =
    GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const [disable, setDisabled] = React.useState(false);
  const { showLoader, hideLoader } = React.useContext(LoaderContext);
  const [statusData, setStatusData] = React.useState(props?.statusData);
  const [memberTokenNo, setMemberTokenNo] = React.useState(null);
  const [memberApplicantType, setMemberApplicantType] = React.useState(null);
  const [insertUpdateData, setInsertUpdateData] = React.useState(false);

  const [isFunctionCall, setIsFunctionCall] = React.useState(false);

  
  const [data, setData] = useState({
    company: null,
    sector: null,
    designation: null,
    department: null,
    location: null,
    unitcode: null,
    salary: null,
    monthlySalary: null,
    isOfflineSubmitted: false,
  });

  // const userTypeId: MemberRegistrationUserType = useSelector(
  //   (state: any) => state?.MemberRegistrationReducer?.userTypeId
  // );

  const isApplicantTypeOthers = useSelector(
    (state: any) => state?.MemberRegistrationReducer?.isApplicantTypeOthers
  );

  const [isApplicantTypeOthersOld, setIsApplicantTypeOthersOld] =
    useState(false);

  useEffect(() => {
    if (isApplicantTypeOthersOld != isApplicantTypeOthers) {
      setIsApplicantTypeOthersOld(isApplicantTypeOthers);
      setData({ ...data, department: null, designation: null });
    }
  }, [isApplicantTypeOthers]);

  useEffect(() => {
    geEmployeeDetails();
    sectoroptions();
    companyoptions();
    locationoptions();
    departmentdropdown();
    designationoptions();
    // unitcodeoptions();
  }, []);

  useEffect(() => {
    debugger
    
    if (
      isFunctionCall === true &&
      //companyOptions.length > 0 &&
      // sectorOptions.length > 0 &&
      // locationOptions.length > 0 &&
      // departmentOptions.length > 0 &&
      // designationOptions.length > 0 &&
      // unitcodeOptions.length > 0 &&
       memberTokenNo &&
      (memberApplicantType === 1 || memberApplicantType === "1")
    ) {
      getCoreEmployeeDetails(memberTokenNo);
      setIsFunctionCall(false);
    }
  }, [
    companyOptions,
    // sectorOptions,
    // locationOptions,
    // departmentOptions,
    // designationOptions,
    // unitcodeOptions,
    // memberTokenNo,
    // memberApplicantType,
    isFunctionCall,
  ]);

  const sectoroptions = async () => {
    showLoader();
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "sectordd",
    });
   
    if (resp?.Data?.length > 0) {
      setSectorOptions(resp?.Data);
    }
    hideLoader();
  };
  const companyoptions = async () => {
    showLoader();
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "companydd",
    });
    if (resp?.Data?.length > 0) {
      setCompanyOptions(resp?.Data);
    }
    hideLoader();
  };
  // const locationoptions = async () => {
  //   showLoader();
  //   const resp = await APICall(CommonDropdownData, {
  //     dropdownName: "locationdd",
  //   });
  //   if (resp?.Data?.length > 0) {
  //     setLocationOptions(resp?.Data);
  //   }
  //   hideLoader();
  // };
  const locationoptions = async () => {
      debugger
      try {
       
    
        const resp = await APICall(GetLocationData, {
          dropdownName: "locationdd",
        });
    
       
    
        if (resp?.Data?.length > 0) {
        
          setLocationOptions(resp.Data);
        } else {
          console.warn("No data received or empty list for locationdd.");
        }
    
      } catch (error) {
        console.error("Error while fetching location options:", error);
      }
    };
  const departmentdropdown = async () => {
    showLoader();
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "departmentdd",
    });
    if (resp?.Data?.length > 0) {
      setDepartmentOptions(resp?.Data);
    }
    hideLoader();
  };
  const designationoptions = async () => {
    showLoader();
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "designationdd",
    });
    if (resp?.Data?.length > 0) {
      setDesignationOptions(resp?.Data);
    }
    hideLoader();
  };
  const unitcodeoptions = async (dataVal, shouldSetData = true) => {
    debugger
    showLoader();
    const resp = await APICall(getUnitCodeDropdownById, {
      Id: dataVal.value,
    });

    if (shouldSetData) {
      setData({ ...data, ["company"]: dataVal, unitcode: [] });
    } 
    setUnitCodeOptions([]);
    if (resp?.Data?.Data?.length > 0) {
          // Set the unitcode options based on the response
        setUnitCodeOptions(resp.Data.Data);
        // Optionally, you can set the first available unitcode as the default
        setData(prevData => ({
          ...prevData,
          unitcode: resp.Data.Data[0].value,  // or any default logic you want
        }));
      // setUnitCodeOptions(resp?.Data.Data); // comment code by me 
    }
    hideLoader();
    return false;
  };

  const onChange = (key, value) => {
    if (key == "company") {
      unitcodeoptions(value);
    } else {
      setData({ ...data, [key]: value });
    }
  };

  const handleKeyPress = (event) => {
    // Prevent typing of minus sign (-)
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };
  const { selectNextTab, selectPreviousTab, disabled } = props;
  const [error, setError] = React.useState<any>({});
  const onSubmit = async () => {
    let errorObj = {};
    
    if (
      data.company == null ||
      data.company == undefined ||
      Object.keys(data.company).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.company]: "This field is Required",
      };
    }
    if (
      data.sector == null ||
      data.sector == undefined ||
      Object.keys(data.sector).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.sector]: "This field is Required",
      };
    }
    if (
      data.location == null ||
      data.location == undefined ||
      Object.keys(data.location).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.location]: "This field is Required",
      };
    }
    if (
      data.department == null ||
      data.department == undefined ||
      (typeof data.department == "string" &&
        String(data.department).trim().length == 0) ||
      Object.keys(data.department).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.department]: "This field is Required",
      };
    }
    if (
      data.designation == null ||
      data.designation == undefined ||
      (typeof data.designation == "string" &&
        String(data.designation).trim().length == 0) ||
      Object.keys(data.designation).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.designation]: "This field is Required",
      };
    }

    if (
      data.unitcode == null ||
      data.unitcode == undefined ||
      Object.keys(data.unitcode).length <= 0
    ) {
      errorObj = {
        ...errorObj,
        [data.unitcode]: "This field is Required",
      };
    }
    // if (data.salary == null) {
    //   errorObj = {
    //     ...errorObj,
    //     [data.salary]: "This field is Required",
    //   };
    // }
    if (data.monthlySalary == null) {
      errorObj = {
        ...errorObj,
        [data.monthlySalary]: "This field is Required",
      };
    }

    const monthlySalaryF = parseFloat(
      data?.monthlySalary == null || data?.monthlySalary == undefined
        ? 0
        : data?.monthlySalary.toString().replace(/,/g, "")
    );
    if (data?.monthlySalary && data?.salary) {
      const salaryF = parseFloat(data?.salary?.toString()?.replace(/,/g, ""));
      if (salaryF !== 0 && monthlySalaryF > salaryF) {
        errorObj = {
          ...errorObj,
          [data.monthlySalary]:
            "Monthly PF Base Salary should be less than Annual Salary",
        };
      }
    } 
    if (
      data?.monthlySalary == null ||
      data?.monthlySalary == undefined
    ) {
      errorObj = {
        ...errorObj,
        [data.monthlySalary]: "This field is Required",
      };
    } 
    // if (data?.salary == null || data?.salary == undefined) {
    //   errorObj = {
    //     ...errorObj,
    //     [data?.salary]: "This field is Required",
    //   };
    // }

    if (Object.keys(errorObj).length === 0) {
      // const checkemployeedetails = await geEmployeeDetails();
      // if (
      //   checkemployeedetails === null ||
      //   Object.keys(checkemployeedetails).length === 0
      // ) {
      let param = {
        MemberId: memberid,
        CompanyId: data.company.value,
        SectorId: data.sector.value,
        LocationId: data.location.value,
        DepartmentId: !isApplicantTypeOthers
          ? data.department.value
          : data.department,
        DesignationId: !isApplicantTypeOthers
          ? data.designation.value
          : data.designation,
        UnitCodeId: data.unitcode.value,
        Salary: data.salary,
        MonthlyPFBaseSalary: data.monthlySalary,
        IsOfflineFormSubmit: data.isOfflineSubmitted,
        IsUpdate: insertUpdateData,
      };

      const insertData = await APICall(insertUpdateEmployeedetails, param);

      if (insertData.Data != null) {
        hideLoader();
        selectNextTab();
      } else {
        hideLoader();
        notify(ToastType.Error, insertData.Message);
      }
      // } else {
      //   hideLoader();
      //   selectNextTab();
      // }
    }
    setError(errorObj);
  };
  const geEmployeeDetails = async () => {
    let param = `${getEmploymentDetailsByMemberId}`;
    let requestBody = { MemberId: memberid };
    const insertData = await APICall(param, requestBody);
    // return insertData.Data;

    
    // return;
    if (insertData.Data != null) {
      setInsertUpdateData(true);
      let data = {
        company: {
          label: insertData.Data.CompanyName,
          value: insertData.Data.CompanyId,
        },
        sector: {
          label: insertData.Data.SectorName,
          value: insertData.Data.SectorId,
        },
        designation: !isApplicantTypeOthers
          ? {
              label: insertData.Data.DesignationName,
              value: insertData.Data.DesignationId,
            }
          : insertData.Data.DesignationName,
        department: !isApplicantTypeOthers
          ? {
              label: insertData.Data.DepartmentName,
              value: insertData.Data.DepartmentId,
            }
          : insertData.Data.DepartmentName,
        location: {
          label: insertData.Data.LocationName,
          value: insertData.Data.LocationId,
        },
        unitcode: {
          label: insertData.Data.UnitCodeName,
          value: insertData.Data.UnitCodeId,
        },
        salary: Number(insertData.Data.Salary)
          .toLocaleString("en-IN"),
        monthlySalary: Number(insertData.Data.MonthlyPFBaseSalary)
         .toLocaleString("en-IN"),
        // salary: Number(insertData.Data.Salary).toLocaleString(),
        // monthlySalary: Number(
        //   insertData.Data.MonthlyPFBaseSalary
        // ).toLocaleString(),
        isOfflineSubmitted: insertData.Data.IsOfflineFormSubmit,
      };

      if (insertData?.Data?.TokenNo) {
        setMemberTokenNo(insertData?.Data?.TokenNo);
      }
      if (insertData?.Data?.ApplicantType) {
        setMemberApplicantType(insertData?.Data?.ApplicantType);
      }
      if (insertData?.Data?.CompanyId && data?.company) {
        await unitcodeoptions(data?.company, false);
      }
      setData({ ...data });
      if (
        [
          ApplicationStatus.MemberRegistrationModule_Draft,
          ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
        ].includes(insertData.Data.StatusId)
      ) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      let requestParams = { MemberId: memberid };
      const res = await APICall(getPersonalDetailsByMemberId, requestParams);
      if (res.Message === "Ok") {
        if (res.Data !== null) {
          if (res?.Data?.TokenNo) {
            setMemberTokenNo(res?.Data?.TokenNo);
          }
          if (res?.Data?.ApplicantType) {
            setMemberApplicantType(res?.Data?.ApplicantType);
          }
        }
        setIsFunctionCall(true);
      }
    }
  };
  const getCoreEmployeeDetails = async (TokenNo) => {
    let requestBody = { TokenNo: TokenNo };
    const insertData = await APICall(
      getCoreUsersEmploymentDetailsByTokenNo,
      requestBody
    );
    debugger
    if (insertData.Data != null) {
      let coreEmpData =
        insertData.Data as GetCoreUsersEmploymentDetailsByTokenNoResponseModel;
      let newData = { ...data };
      if (coreEmpData?.Company) {
        // let newCo = [...companyOptions];
        newData.company = companyOptions.find(
          (co) => co?.code === coreEmpData?.Company
        );
        if (newData.company) {
          newData.company.disable = true;
        }
      }
      if (coreEmpData?.SectorId) {
        newData.sector = {
          label: coreEmpData?.SectorName,
          value: coreEmpData?.SectorId,
          disable: true,
        };
      }

      if (coreEmpData?.DesignationId && !isApplicantTypeOthers) {
        newData.designation = {
          label: coreEmpData?.DesignationName,
          value: coreEmpData?.DesignationId,
          disable: true,
        };
      }
      if (coreEmpData?.DepartmentId && !isApplicantTypeOthers) {
        newData.department = {
          label: coreEmpData?.DepartmentName,
          value: coreEmpData?.DepartmentId,
          disable: true,
        };
      }
      if (coreEmpData?.Location) {
        newData.location = locationOptions.find(
          (lo) => lo?.label === coreEmpData?.Location
        );
        if (newData.location) {
          newData.location.disable = true;
        }
      }
      debugger 
      if (coreEmpData?.UnitCodeId) {
        newData.unitcode = {
          label: coreEmpData?.UnitCodeName,
          value: coreEmpData?.UnitCodeId,
          disable: true,
        };
      } else if (coreEmpData?.Company) {
        // Trigger unitcode options population based on Company
        unitcodeoptions(newData.company, false);  // Pass company info to trigger unitcode dropdown
      }
      else if (coreEmpData?.Company) {
        // Trigger unitcode options population based on Company
        unitcodeoptions(newData.company, false);  // Pass company info to trigger unitcode dropdown
      }
      setData({ ...newData });
    }
    return insertData.Data;
  };

  const testData = () => {
    if (!enableTestData) {
      return;
    }
    let newData = {
      company: companyOptions[randomNumber(0, companyOptions.length - 1)],
      sector: sectorOptions[randomNumber(0, sectorOptions.length - 1)],
      designation:
        designationOptions[randomNumber(0, designationOptions.length - 1)],
      department:
        departmentOptions[randomNumber(0, departmentOptions.length - 1)],
      location: locationOptions[randomNumber(0, locationOptions.length - 1)],
      unitcode: unitcodeOptions[randomNumber(0, unitcodeOptions.length - 1)],
      salary: randomNumber(100000, 9999999),
      monthlySalary: randomNumber(1000, 99999),
      isOfflineSubmitted: true,
    };
    setData({ ...newData });
  };

  return (
    <>
      <div className="">
        <div className="col-lg-12 col-md-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label onDoubleClick={testData}>Company</label>
              <sup>*</sup>
              <SelectForm
                value={data.company}
                placeholder="Select Company"
                options={companyOptions}
                onChange={(val: any) => onChange("company", val)}
                isDisabled={data?.company?.disable || disable}
              />
              {error[data.company] && (
                <p style={{ color: "red" }}>{error[data.company]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Sector</label>
              <sup>*</sup>
              <SelectForm
                value={data.sector}
                placeholder="Select Sector"
                options={sectorOptions}
                onChange={(val: any) => onChange("sector", val)}
                isDisabled={data?.sector?.disable || disable}
              />
              {error[data.sector] && (
                <p style={{ color: "red" }}>{error[data.sector]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Locations</label>
              <sup>*</sup>
              <SelectForm
                value={data.location}
                placeholder="Select Location"
                options={locationOptions}
                onChange={(val: any) => onChange("location", val)}
                isDisabled={data?.location?.disable || disable}
              />
              {error[data.location] && (
                <p style={{ color: "red" }}>{error[data.location]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Department</label>
              <sup>*</sup>
              {!isApplicantTypeOthers ? (
                <SelectForm
                  value={data.department}
                  placeholder="Select Department"
                  options={departmentOptions}
                  onChange={(val: any) => onChange("department", val)}
                  isDisabled={data?.department?.disable || disable}
                />
              ) : (
                <InputForm
                  placeholder={""}
                  value={data.department}
                  onChange={(event: any) => {
                    onChange("department", event?.target?.value);
                  }}
                  type="text"
                  isDisabled={disable}
                />
              )}
              {error[data.department] && (
                <p style={{ color: "red" }}>{error[data.department]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Designation</label>
              <sup>*</sup>

              {!isApplicantTypeOthers ? (
                <SelectForm
                  value={data.designation}
                  placeholder="Select Designation"
                  options={designationOptions}
                  onChange={(val: any) => onChange("designation", val)}
                  isDisabled={data?.designation?.disable || disable}
                />
              ) : (
                <InputForm
                  placeholder={""}
                  value={data.designation}
                  onChange={(event: any) => {
                    onChange("designation", event?.target?.value);
                  }}
                  type="text"
                  isDisabled={disable}
                />
              )}
              {error[data.designation] && (
                <p style={{ color: "red" }}>{error[data.designation]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Unit Code</label>
              <sup>*</sup>
              <SelectForm
                value={data.unitcode}
                placeholder="Select Unit Code"
                options={unitcodeOptions}
                onChange={(val: any) => onChange("unitcode", val)}
                isDisabled={data?.unitcode?.disable || disable}
              />
              {error[data.unitcode] && (
                <p style={{ color: "red" }}>{error[data.unitcode]}</p>
              )}
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Annual Salary</label>
              {/* <sup>*</sup> */}
              <InputForm
                placeholder={""}
                value={data.salary}
                onChange={(val: any) => {
                  let value = val.target.value.replace(/[^0-9]/g, "");

                  if (value.length < 9) {
                    // value = value
                    //   .toString()
                    //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    value = value
                      .toLocaleString("en-IN");
                    onChange("salary", value);
                  }
                }}
                type="text"
                isDisabled={disable}
                onKeyPress={(e) => handleKeyPress(e)}
                maxlength={20}
              />
              {/* {error[data.salary] && (
                <p style={{ color: "red" }}>{error[data.salary]}</p>
              )} */}
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4 ">
              <div className="form-group"></div>
              <label>Monthly PF Base Salary</label>
              <sup>*</sup>
              <InputForm
                placeholder={""}
                value={data.monthlySalary}
                onChange={(val: any) => {
                  let value = val.target.value.replace(/[^0-9]/g, "");

                  if (value.length < 9) {
                    // value = value
                    //   .toString()
                    //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    value = value
                      .toLocaleString("en-IN");
                    onChange("monthlySalary", value);
                  }
                }}
                type="text"
                isDisabled={disable}
                onKeyPress={(e) => handleKeyPress(e)}
                maxlength={20}
              />
              {error[data.monthlySalary] && (
                <p style={{ color: "red" }}>{error[data.monthlySalary]}</p>
              )}
            </div>
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="" style={{ marginTop: "30px" }}>
                <input
                  autoComplete={AutoCompleteValue}
                  placeholder={""}
                  value={""}
                  checked={data.isOfflineSubmitted}
                  onChange={(val: any) => {
                    let value = val.target.checked;
                    onChange("isOfflineSubmitted", value);
                  }}
                  type="checkbox"
                  disabled={disable}
                />{" "}
                <span style={{ marginLeft: "12px" }}>
                  Check on the checkbox if you have submitted member enrollment
                  from offline
                </span>
              </div>
            </div>
          </div>
          <div
            className="p-2 d-flex justify-content-end"
            style={{ marginTop: 20 }}
          >
            <ButtonComponent
              icon={"fas fa-arrow-left"}
              value={"Back"}
              className="btn btn-primary btn-back"
              onClick={selectPreviousTab}
            />
            <ButtonComponent
              icon={"far fa-times-circle"}
              value={"Exit"}
              style={{ marginLeft: "10px" }}
              className="btn btn-primary"
              onClick={() => navigate("/")}
            />
            <ButtonComponent
              icon={"fas fa-arrow-right"}
              value={disable ? "Next" : "Save & Next"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={onSubmit}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default EmployeeDetails;

